"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var LAYER_WIDTH = exports.LAYER_WIDTH = 30;
var SCROLLBAR_MIN_WIDTH = exports.SCROLLBAR_MIN_WIDTH = 14;
var SCROLLBAR_WIDTH = exports.SCROLLBAR_WIDTH = 10;
var CELL_PADDING_HEIGHT = exports.CELL_PADDING_HEIGHT = 26;